export const GENDER_TYPES = {
    men: 'men',
    women: 'women',
    kids: 'kids'
};
